module.exports = __webpack_public_path__ + "img/11_77.e00c8c4e.png";